module.exports = __webpack_public_path__ + "img/event_difficulty.5ba04706.svg";